export default {
  redisKey: [
    'SUCCESS_REFER_EARN',
    'DITTO_CONFIG',
    'LOYALTY_CONFIG',
    'timerForWalletResendOTP',
    'VC_FULL_RIM',
    'VC_HALF_RIM',
    'VC_RIMLESS',
    'ENABLE_FRESHWORKS_DESKTOP',
    'PRESCRIPTION_MODAL',
    'BLUE_CUT_LOGO',
    'SORT_PACKAGES_BY_PRICE_DESC',
    'SKIP_COATINGS_STEP',
    'SHOW_MORE_PAYMENT_OPTION',
    'SHOW_MORE_PAYMENT_OPTION_LIMIT',
    'GOOGLE_MAP_KEY',
    'GOLD_MEMBERSHIP_CONFIG',
    'PDP_CL_BOX_CONFIG',
    'YOTPO_WIDGETS_CONFIG',
    'USER_SAVED_CARD',
    'QR_CODE_SCAN_EXPIRE_TIME',
    'FRESHDESK_WIDGET_KEY',
    'ENABLE_FRESHWORKS',
    'UPDATE_TOAST_CONFIG',
    'APP_DOWNLOAD_ONELINK',
    'NEW_CAPTURE_NUMBER_EXPIRY',
    'NEW_CAPTURE_NUMBER_CLOSE_EXPIRY',
    'DISABLE_POWER_MISS_INFO',
    'HIDE_RECENT_PRODUCTS',
    'RECENT_VIEWED_COUNT',
    'RECENT_VIEWED_PER_SLIDE',
    'HIDE_RECOMMENDED_PRODUCTS',
    'RECOMMENDED_PRODUCTS_TITLE',
    'RECOMMENDED_PRODUCTS_COUNT',
    'RECOMMENDED_PRODUCTS_PER_SLIDE',
    'DISABLE_BUY_CALL',
    'BOGO_BANNER_DETAILS',
    'OOS_CONFIG',
    'SHOW_HIDE_LENSKART_GOLDBANNER',
    'LKCashEnabled',
    'BOGO_WORKFLOW',
    'CATEGORY_PAGE_SIZE_COUNT',
    'STORE_LOCATOR_URL',
    'LISTING_PAGE_SIZE',
    'SKIP_BTN_TIMEOUT',
    'MSITE_SHOW_MORE_PAYMENT_OPTION',
    'MSITE_SHOW_MORE_PAYMENT_OPTION_LIMIT',
    'CL_SURVEY',
    'OFFLINE_ORDER_NUMBER',
    'MSITE_EYE_SUN_CTA_CONFIG',
    'PRODUCTS_GST',
    'STORE_FRAME_SIZE',
    'isEmailMandatoryForDitto',
    'hideDittoPhoneCapture',
    'TRY_FRAMES_3D_BANNER',
    'PREPAID_DISCOUNT_SEAMLESS',
    'WHITELISTED_URL_FOR_SEO',
    'SL_EXCEEDED_MESSAGE',
    /** CODE CHANGES DONE FOR ABOVE KEYS */
    'CONFIG_CTA_DESKTOP',
    'ADDTOCART_BUTTON_CONFIG',
    'MISSED_CALL_CONFIG',
    'TRY_ON_DESKTOP',
    'RBI_POLICY_MARKETPLACE_CONFIG',
    'PHONE_NUMBER_CAPTURE_CONFIG',
    'FACE_ANALYSIS',
    'PLP_CONFIG',
    'SUBSCRIPTION_CONFIG',
    'frameSizeConfig',
    'GUEST_MSG',
    'PDP_CONFIG',
    'MISSCALL_CONFIG',
    'lenskartGoldBanner',
    'TAT_INFO',
    'BUY_ON_CALL_CONFIG',
    'RECENT_VIEWED_TITLE',
    'PACKAGES_CONFIG',
    'LK_CONFIG_MESSAGE',
    'CONFIG_CTA_MSITE',
    'BOGO_OFFER_CONFIG',
    'NEW_AUTH_CONFIG',
    'APP_DOWNLOAD_PUSH_CONFIG',
    'OFFLINE_ORDER_NUMBER',
    'BRAND_PRICE_APP_OFFER',
    'CONTACTS_OFFER',
    'WHATSAPP_OPTIN',
    'EXCHANGE_CONFIG',
    'BUY_ON_CALL_WIDGET',
    'BIN_CONFIG',
    'PDP_CTA_CONFIG',
    'lensPackageTextConfig',
    'POWER_STATUS_MESSAGE',
    'POST_CART_POWER',
    'ORDER_STATUS',
    'CART_CONFIG'
  ]
};
